export const getListDescription = (description = '') => {
    // Убираем теги, разделяем на предложения с сохранением точки.
    return  description?.replace(/<\/?p>/g, '')
        .split(/(?<=\.\s)/)
        .filter(item => item.length > 0) || [];
};
